import { Box, TableContainer } from "@material-ui/core";
import { FC } from "react";
import { useStyles } from "./styles";
import { useTypeSelectors } from "hooks/useTypeSelectors";
import Loader from "router/components/Loader";
import ScheduleHead from "./ScheduleHead";
import ScheduleTable from "./ScheduleTableBody";
import { useTableSync } from "hooks/useTableSync";

const SchedulePage: FC = () => {
  const classes = useStyles();
  const { loadingData } = useTypeSelectors((state) => state.scheduleTable);
  const { t1Ref, t2Ref } = useTableSync();

  return (
    <Box className={classes.root}>
      <Loader isLoading={loadingData} />
      <ScheduleHead />
      <Box className={classes.contentBox}>
        <TableContainer className={classes.tableContainer} ref={t1Ref} key="schedulecontainer1">
          <ScheduleTable tableNumber={1} />
        </TableContainer>
        <TableContainer className={classes.tableContainer2} ref={t2Ref} key="schedulecontainer2">
          <ScheduleTable tableNumber={2} />
        </TableContainer>
      </Box>
    </Box>
  );
};

export default SchedulePage;
